/**
 * 礼物兑换
 */

define(function(require, exports, module) {

    const Base = require('c-base');

    const PopLayer = require('../lib/poplayer');

    const GalaPop = Base.extend({
        defaults: {
            title: '',
        	context: '',
        	btnContext: ''
        },

        initialize() {
            let self = this;
            self.Parent.apply(self, arguments);
        },

        getContent(){
            return `<div class="content-wrap">
                            <div class="content-ico"></div>
                            <div class="content-main">
                                <div class="content-hd">${ this.get('title') }</div>
                                <div class="content-bd">
                                    ${ this.get('context')}
                                </div>
                                <div class="content-ft">
                                    ${ this.get('btnContext') }
                                </div>
                            </div>
                        </div>`;
        },

        create(count){
            let self = this;
            this.popup = new PopLayer({
                content: this.getContent()
            });

            this.popup.on('create',(el)=>{
            	this.get('onCreate') && this.get('onCreate')(el,this.popup,this);
            })
            this.popup.on('close',(el)=>{
                this.get('onClose') && this.get('onClose')(el,this.popup,this);
            })
            this.popup.create();

        },

        close(){
            this.popup.emit('close');
            this.popup.destroy();
            this.popup.mask.destroy();
        },

        refresh(){
            this.popup.get('el').find('.widget-poplayer-content').html(this.getContent());
        }
    });

    module.exports = GalaPop;
});



// WEBPACK FOOTER //
// ./js/lib/normalPop.js